import { Component, ChangeDetectionStrategy, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';

import { Store } from '@ngrx/store';
import { Observable } from 'rxjs/Observable';

import { ClinicModel, ClinicStoreModel } from './clinic.model';

import { State } from '../../reducers/index';
import * as headerAction from '../../actions/header.action';
import * as infoAction from '../../actions/info.action';
import * as dataAction from '../../actions/data.action';
import * as bookingAction from '../../actions/booking.action';

import { SHOW_HEADER, OVERLAY_START } from '../../actions/header.action';
import { INFO_UPDATE } from '../../actions/info.action';
import { DATA_REQUEST } from '../../actions/data.action';
import { Booking } from '../../actions/booking.action';

@Component({
  selector: 'consentz-clinic-component',
  templateUrl: './clinic.template.html',
  styleUrls: ['./clinic.styles.scss']
})
export class ClinicComponent implements OnInit, OnDestroy {
  public model: ClinicModel = new ClinicModel(
    JSON.parse(localStorage.getItem('currentBookingOptions')),
    localStorage.getItem('AppId') ? localStorage.getItem('AppId') : window.location.hash.split('/')[1]
  );
  public dataStore: ClinicStoreModel = new ClinicStoreModel();

  constructor(
    private router: Router,
    private store: Store<State>
  ) {
    // show header, allow ovelay, get clinics request
    this.store.dispatch({ type: SHOW_HEADER });
    this.store.dispatch({ type: OVERLAY_START });
    this.store.dispatch({
      type: DATA_REQUEST,
      payload: {
        requestUrl: `/online-booking/${localStorage.getItem('AppId')}/clinics`
      }
    });
    // subscribtion on widget options, server data, local selections
    this.dataStore.subscribtion$ = store.select<any>('booking').subscribe((data: Booking) => {
      if (Object.keys(data).find(key => key === 'primaryFontColour')) {
        this.model.currentBookingOptions = data;
      }
    });
    this.dataStore.model$ = store.select<any>('data');
    this.dataStore.info$ = store.select<any>('info');
  }
  // add clinic to store
  public selectClinic(clinic: any, index: number): void {
    this.model.indexOfChosenClinic = index;
    localStorage.setItem('clinicId', clinic.id);
    this.store.dispatch({
      type: INFO_UPDATE,
      payload: { clinic }
    });
  }
  // detect window size
  public sizeOfScreen(): number {
    return window.innerHeight;
  }
  public checkPosition(): number {
    if (localStorage.getItem('currentUser')) {
      this.router.navigate([this.model.widgetIdForRouting + '/cabinet']);
    } else {
      this.router.navigate([this.model.widgetIdForRouting + '/home']);
    }
    return window.innerHeight;
  }
  // set dynamic color for interface
  public ngOnInit(): void {
    let style: any = null;
    if (document.querySelector('#css-dynamic-class')) {
      style = document.querySelector('#css-dynamic-class');
    } else {
      style = document.createElement('style');
      style.type = 'text/css';
      style.id = 'css-dynamic-class';
    }
    style.innerHTML = `.css-dynamic-class { background-color: ${this.model.currentBookingOptions.secondaryInterfaceColour}!important; }`;
    document.getElementsByTagName('head')[0].appendChild(style);

    const element: any = document.querySelector('.ui-scrollpanel-bar-y');
    element.classList.add('css-dynamic-class');
  }
  // unsubscribe from store
  public ngOnDestroy(): void {
    this.dataStore.subscribtion$.unsubscribe();
  }
}



// WEBPACK FOOTER //
// /Users/dtrubetskoi/Desktop/projects/online-booking-widget/src/app/components/clinic/clinic.component.ts